<template>
  <div class="mb-4">

    <!--#region -- Content ---->

    <div class="stage-header border-bottom mb-4">
      <!--#region Header-->
      <b-tabs pills card>
        <b-tab title="FTIE Ticket Basic Info" active>
          <div class="caption-label">FTIE Ticket Basic Information</div>
          <div class="row mb-4">
            <div class="col-4">
              <div class="header-col">
                <div>FTIE ID</div>
                <div>
                  {{ _.get(ticketWithUniqueInfo, 'ftie_id', '') }}
                  <a v-if="ticketWithUniqueInfo !== null
                     && _.get(ticketWithUniqueInfo, 'salesforce_es_id', null) != null"
                     class="link"
                     target="_blank"
                     :href="safeUrl(`${ frontEndUrlToUse }engineering-service/opty-id/${ _.get(ticketWithUniqueInfo, 'salesforce_es_id', null) }`)">
                    (view ES details)
                  </a>
                </div>
              </div>


              <div class="header-col">
                <div>Device</div>
                <div>{{ _.get(ticketWithUniqueInfo, 'device', '') }}</div>
              </div>
              <div class="header-col">
                <div>Status</div>
                <div>{{ _.get(ticketWithUniqueInfo, 'status', '') }}</div>
              </div>

            </div>
            <div class="col-4">
              <div class="header-col">
                <div>Salesforce Opportunity</div>
                <gtc-opportunity v-if="ticketWithUniqueInfo != null" :opportunityId="ticketWithUniqueInfo.salesforce_opty_id"
                                 :opportunityName="ticketWithUniqueInfo.salesforce_opty_name" />
              </div>
              <div class="header-col">
                <div>Contact Sales</div>
                <div>{{ _.get(ticketWithUniqueInfo, 'contact_sales', '') }}</div>
              </div>
              <div class="header-col">
                <div>GRO Owner</div>
                <div>{{ _.get(ticketWithUniqueInfo, 'gro_owner', '')  }}</div>
              </div>
            </div>
            <div class="col-4">
              <div class="header-col">
                <div>GRO</div>
                <div>{{ _.get(ticketWithUniqueInfo, 'site', '')  }}</div>
              </div>
              <div class="header-col">
                <div>Customer</div>
                <div>{{ _.get(ticketWithUniqueInfo, 'customer', '') }}</div>
              </div>
              <div class="header-col">
                <div>Vertical</div>
                <div>{{ _.get(ticketWithUniqueInfo, 'vertical', '')  }}</div>
              </div>
            </div>
            <div class="col-8">
              <div class="header-col">
                <div>GTC Owner</div>
                <div>{{ _.get(ticketWithUniqueInfo, 'gtc_owner', '')  }}</div>
              </div>
            </div>
            <div class="col-12">
              <div class="header-col">
                <div>Description</div>
                <div v-if="ticketWithUniqueInfo!=null" v-html="safeHtml(ticketWithUniqueInfo.description)"></div>
              </div>
            </div>
            <div class="col-12">
              <div class="header-col">
                <div>Shipping PN</div>
                <div v-if="ticketWithUniqueInfo !== null && _.get(ticketWithUniqueInfo, 'shipping_pn_list', null) != null">
                  <span v-for="item in ticketWithUniqueInfo.shipping_pn_list"> {{ item }} </span>
                </div>

              </div>
            </div>

            <div class="col-12 align-self-right">
              <a v-if="ticketWithUniqueInfo !== null && ticketWithUniqueInfo.nre_exist === true"
                 class="btn btn-primary"
                 style="width: 9.5rem"
                 target="_blank"
                 :href="safeUrl(`${ $root.frontEndUrl }/dashboard/${ ticketWithUniqueInfo.ftie_id }`)">ETO</a>
            </div>
          </div>
        </b-tab>

        <b-tab v-if="ticketWithUniqueInfo !=null && ticketWithUniqueInfo.salesforce_opty_id != null && (userSites.includes(ticketWithUniqueInfo.site) || userSites.includes('Getac'))" title="Opportunity Info" @click="getSfEsOptyInfo">
          <div class="caption-label">Opportunity Info</div>
          <div class="row mb-4">
            <div class="col-4">
              <div class="header-col">
                <div>ES ID (link to SFDC)</div>
                <gtc-opportunity v-if="es_main_es_info !== null && _.get(es_main_es_info, 'opty_obj_id', null) != null"
                                 :opportunityId="_.get(es_main_es_info, 'opty_obj_id', null)"
                                 :opportunityName="_.get(es_main_es_info, 'es_id', null)" />
              </div>
              <div class="header-col">
                <div>Vertical Industry</div>
                <div>{{ _.get(sf_opty_info, 'VERTICAL_INDUSTRY__C', '') }} </div>
              </div>
              <div class="header-col">
                <div>RSM Territory</div>
                <div>{{ _.get(sf_opty_info, 'RSM_TERRITORY_DEL__C', '') }}</div>
              </div>
              <div class="header-col">
                <div>Unit Qty</div>
                <div>{{ _.get(sf_opty_info, 'TOTALOPPORTUNITYQUANTITY', '') }}</div>
              </div>
              <div class="header-col">
                <div>Amount</div>
                <div>{{ _.get(sf_opty_info, 'AMOUNT', '') }}</div>
              </div>
              <div class="header-col">
                <div>Stage</div>
                <div>{{ _.get(sf_opty_info, 'STAGE', '') }}</div>
              </div>
            </div>
            <div class="col-4">
              <div class="header-col-mid">
                <div>Probability (%)</div>
                <div>{{ _.get(sf_opty_info, 'PROBABILITY', '') }}</div>
              </div>
              <div class="header-col-mid">
                <div>Technical Stage</div>
                <div>{{ _.get(sf_opty_info, 'TECHNICAL_STAGE', '') }}</div>
              </div>
              <div class="header-col-mid">
                <div>Primary Campaign Source</div>
                <div>{{ _.get(sf_opty_info, 'CAMPAIGN_SOURCE', '') }}</div>
              </div>
              <div class="header-col-mid">
                <div>User Group</div>
                <div>{{ _.get(sf_opty_info, 'USER_GROUP', '') }}</div>
              </div>
              <div class="header-col-mid">
                <div>System Quantity</div>
                <div>{{ _.get(sf_opty_info, 'SYSTEM_QUANTITY', '') }}</div>
              </div>
            </div>
            <div class="col-4">
              <div class="header-col">
                <div>Country</div>
                <div>{{ _.get(sf_opty_info, 'COUNTRY__C', '') }}</div>
              </div>

              <div class="header-col">
                <div>Opportunity Currency</div>
                <div>{{_.get(sf_opty_info, 'OPPORTUNITY_CURRENCY', '') }}</div>
              </div>
              <div class="header-col">
                <div>Lead Source</div>
                <div>{{ _.get(sf_opty_info, 'LEAD_SOURCE', '') }}</div>
              </div>
              <div class="header-col">
                <div>Registration Date</div>
                <div>{{ _.get(sf_opty_info, 'REGISTRATION_DATE', '') | dateTimeFormat}}</div>
              </div>
              <div class="header-col">
                <div>Decision Date</div>
                <div>{{ _.get(sf_opty_info, 'DECISION_DATE', '') | dateTimeFormat}}</div>
              </div>
            </div>
            <div class="col-12">
              <div class="header-col">
                <div>Customer Comments</div>
                <div>{{ _.get(sf_opty_info, 'CUSTOMER_COMMENTS', '') }}</div>
              </div>
            </div>
            <div class="col-12">
              <div class="header-col">
                <div>Latest Update Info</div>
                <div v-if="sf_opty_info != null" v-html="safeHtml(sf_opty_info.LATEST_UPDATE_INFORMATION)"></div>
              </div>
            </div>

          </div>
        </b-tab>
        <b-tab v-if="ticketWithUniqueInfo !=null
               && (login_user_name === ticketWithUniqueInfo.gtc_owner || login_user_name === 'power' || userRoles.includes('Admin'))"
               title="SKU PN" @click="getSfProductline">
          <sfdc-prd-line v-if="sfdcProducts!=null"
                         :prop_sfdc_page_obj="sfdcProducts"
                         :prop_basic_info="basicInfo"
                         :prop_user="login_user_name"
                         :prop_request_detail_id="ftie_page_obj.request_detail_id" />
        </b-tab>
      </b-tabs>
    </div>

    <div class="stage-header border-bottom mb-4">
      <div class="label" style="padding-left: 33px;">
        <br>
        Inventory of Ticket Unique Component
        <div class="d-flex">
          <div v-if="ticketWithUniqueInfo !== null && _.get(ticketWithUniqueInfo, 'inventory_info_list', null) != null" class="h5 font-weight-bold">
            {{ ticketWithUniqueInfo.inventory_info_list.length }} Results
            <button class="btn btn-sm btn-link p-0 btn-svg gtc-icon-download"
                    v-b-tooltip.hover title="Download Inventory Report"
                    @click="reportDownload()"></button>
          </div>
          <div v-else class="h5 font-weight-bold">
            Results
          </div>
        </div>
        <b-table v-if=" _.get(ticketWithUniqueInfo, 'inventory_info_list', null) != null" small thead-class="thead-light text-dark"
                 :items="ticketWithUniqueInfo.inventory_info_list" :fields="fields">
          <template #head(possible_surplus)="data">
            {{ data.field.label }}
            <button v-b-modal.modal-2 class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info" v-b-tooltip.hover.left title="計算公式">
            </button>
          </template>
          <template #head(surplus)="data">
            {{ data.field.label }}
            <button v-b-modal.modal-3 class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info" v-b-tooltip.hover.left title="計算公式">
            </button>
          </template>

          <template #cell(unique_component_pn)="data">
            <a class="link" target="_blank" :href="safeUrl(`${ frontEndUrlToUse }inventory/component_pn/${ data.item.unique_component_pn }`)">{{ data.item.unique_component_pn }}</a>
          </template>
          <template #cell(stock_qty)="data">
            <button v-b-modal.modal-1 class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                    @click="showInventoryDetailData(data.item.stock_info_list, data.item.unique_component_pn)" v-b-tooltip.hover.left title="Inventory Detail">
            </button>
            {{  data.item.stock_qty }}
          </template>
          <template #cell(po_qty_total)="data">
            <!--<button v-if="data.item.po_info.po_detail != ''" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info" v-b-tooltip.hover.left :title="`${data.item.po_info.po_detail}`">
          </button>-->
            {{  data.item.po_qty_total }}
          </template>
          <template #cell(pr_qty_total)="data">
            <!--<button v-if="data.item.pr_info.pr_detail != ''" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info" v-b-tooltip.hover.left :title="`${data.item.pr_info.pr_detail}`">
          </button>-->
            {{  data.item.pr_qty_total }}
          </template>


        </b-table>
      </div>

      <div class="table-responsive mt-2" style="min-height: 2.5rem; padding-left: 33px">

      </div>
    </div>

    <!-- REGION FOR POP-UP MODAL -->
    <b-modal centered size="lg"
             id="modal-1"
             :title="`${detaiInventoryToShow.unique_component_pn} Detail Invetory Info`"
             ok-only>

      <b-table :fields="Inventory_fields"
               :items="detaiInventoryToShow.inventory_info_list"
               small
               thead-class="thead-light text-dark"
               :busy="searching"
               ref="DetailModal"
               style="width: calc(100% - 10px)">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>


    </b-modal>

    <b-modal centered size="lg"
             id="modal-2"
             title="Possible surplus 計算公式"
             ok-only>
      Inventory(P + ET1 + WIP stock) + 未交PO數量 + 有效PR的數量-Order數量 = possiblie surplus
    </b-modal>

    <b-modal centered size="lg"
             id="modal-3"
             title="Surplus 計算公式"
             ok-only>
      Inventory(P + ET1 + WIP stock) + 未交PO數量 + 有效PR的數量 - Order數量 - MPS數量 = surplus
    </b-modal>
    <!-- END REGION FOR MODAL -->
  </div>
</template>

<script>
import { faL } from '@fortawesome/free-solid-svg-icons';
/* END EXTERNAL SOURCE */
/* BEGIN EXTERNAL SOURCE */

  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    name: 'gtc-ftie-page',
    props: {
      prop_ftie_page_obj: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },
      prop_user_roles: {
        default: null
      },
    },
    data: function () {
      return {
        ftie_page_obj: null,
        ticketWithUniqueInfo: null,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        fields: [
          { key: 'unique_component_pn', label: 'Unique Compo P/N', thClass: 'align-middle ', thStyle: { width: '10%' }, sortable: true },
          { key: 'unique_component_pn_desc', label: 'Unique Compo P/N Description', thClass: 'align-middle', thStyle: { width: '20%' }, sortable: false },
          { key: 'project_name', label: 'Project Name', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: false },
          { key: 'stock_qty', label: 'Inventory Qty', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: true },
          { key: 'po_qty_total', label: 'PO Qty', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: true },
          { key: 'pr_qty_total', label: 'PR Qty', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: true },
          { key: 'possible_surplus', label: 'Possible Surplus', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: true },
          //{ key: 'high_likely_surplus', label: 'High Likely Surplus', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: true },
          { key: 'surplus', label: 'Surplus', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: true }
        ],
        inMailGroup: false,
        ticket_owner_options: [],
        login_user_name: null,
        userSites: null,
        userRoles: null,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        temp_gtc_owner: '',
        ticketOpen: true,
        sfdcProducts: null,
        es_main_es_info: null,
        sf_es_info: null,
        sf_opty_info: null,
        detaiInventoryToShow: {
          inventory_info_list: [],
          unique_component_pn: null
        },
        Inventory_fields: [
          { key: 'SUBINVENTORY_CODE', label: 'Subinventory Code', thClass: 'align-middle ', thStyle: { width: '10%' }, sortable: true },
          { key: 'SUBINVENTORY_NAME', label: 'Subinventory Name', thClass: 'align-middle', thStyle: { width: '20%' }, sortable: false },
          { key: 'INVENTORY_QTY', label: 'Inventory Qty', thClass: 'align-middle', thStyle: { width: '10%' }, sortable: false },
        ],
        searching: false
      }
    },
    computed: {
      shipping_pn_list_str() {
        let self = this;
        return self.ticketWithUniqueInfo.shipping_pn_list.join(',')
      }
    },
    created() {
      let self = this;
      self.checkLoggedIn();
      self.ftie_page_obj = self.prop_ftie_page_obj;
      let access_flag = self.inventoryReportAccess();
      if (access_flag == false) {
        self.$router.push('/home');
      }
    },
    mounted() {
      let self = this;
      let access_flag = self.inventoryReportAccess();
      if (access_flag == false) {
        self.$router.push('/home');
      } else {
        self.getInventoryByFtie()
      }
    },
    watch: {

    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
        //return 'DEV' !== this.$session.get('mode');
      },

      getInventoryByFtie() {
        let self = this;
        let url = self.$root.baseUrl + '/inventory-management/customization-ship-info/ftie/';
        let request_data = {
          ftie_id: self.$route.params.ftieId
        };
        console.log("request_data:");
        console.log(request_data);
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let uniqueInfoRes = null;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              uniqueInfoRes = JSON.parse(res['ticket_info']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.ticketWithUniqueInfo = uniqueInfoRes;
            eventHub.$emit('loading', false);
          })

      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;

      },

      getOwnerList() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-ftie-owners';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        let gro_owner_list = [];
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              gtc_owner_list = JSON.parse(res['gtc_owner_list']);
              gro_owner_list = JSON.parse(res['gro_owner_list']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            self.ticket_owner_options = gtc_owner_list;
          });
      },

      getFtiePage(ftie_id) {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/page-with-chatroom/';
        let request_data = {
          ftie_id: ftie_id
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let ftie_page_obj = null;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              ftie_page_obj = JSON.parse(res['ftie_page_obj']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.ftie_page_obj = ftie_page_obj;
            if (_.get(self.ftie_page_obj, 'status', '') === 'Close') {
              self.ticketOpen = false;
            } else {
              self.ticketOpen = true;
            }
            eventHub.$emit('loading', false);
          })
      },

      getSfProductline() {
        let self = this;

        let requestData = {
          create_by: self.ftie_page_obj.gtc_owner,
          username: self.login_user_name,
          ftie_id: self.ftie_page_obj.ftie_id,
          detail_id: self.ftie_page_obj.request_detail_id
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/nre/customization-nre-pn/', requestData)
          .then(res => {
            let result = res.data;
            result.basic_info = JSON.parse(result.basic_info);

            if (_.get(result, 'sku_pn_info_list_for_nre', null) !== null &&
              _.size(_.get(result, 'sku_pn_info_list_for_nre', new Array())) > 0) {
              result.sku_pn_info_list_for_nre = JSON.parse(result.sku_pn_info_list_for_nre);
            }

            if (_.get(result, 'ref_sku_info_list', null) !== null &&
              _.size(_.get(result, 'ref_sku_info_list', new Array())) > 0) {
              result.ref_sku_info_list = JSON.parse(result.ref_sku_info_list);
            }

            if (_.get(result, 'sfdc_line_info_list', null) !== null &&
              _.size(_.get(result, 'sfdc_line_info_list', new Array())) > 0) {
              result.sfdc_line_info_list = JSON.parse(result.sfdc_line_info_list);
            }

            console.log("result.sku_pn_info_list_for_nre::");
            console.log(result.sku_pn_info_list_for_nre);
            console.log("result.ref_sku_info_list::");
            console.log(result.ref_sku_info_list);
            console.log("result.basic_info::");
            console.log(result.basic_info);
            console.log("result.sfdc_line_info_list::");
            console.log(result.sfdc_line_info_list);

            self.basicInfo = result.basic_info;
            self.sfdcProducts = result.sfdc_line_info_list

          })
          .finally(() => {
            console.log("COMPLETE /nre/customization-nre-pn/");
            //if (realSkuForNreRefresh !== null && realSkuForNreRefresh !== '') {
            //  self.refreshNreQuotes(realSkuForNreRefresh);
            //}
            //self.searching = false;
            //self.resetAddOrCloneNreModalData(true);
            //self.actionEnable = self.checkActionEnable();
            eventHub.$emit('loading', false);
          });

      },
      getSfEsOptyInfo() {
        let self = this;

        let requestData = {
          es_id: self.ft.salesforce_es_id,
          opty_id: self.ftie_page_obj.salesforce_opty_id
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/ftie/get-sf-info/', requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'es_main_es_info', null) !== null) {
              self.es_main_es_info = JSON.parse(result.es_main_es_info);
            }

            if (_.get(result, 'sf_es_info', null) !== null) {
              self.sf_es_info = JSON.parse(result.sf_es_info);
            }

            if (_.get(result, 'sf_opty_info', null) !== null) {
              self.sf_opty_info = JSON.parse(result.sf_opty_info);
            }
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            console.log("Befreo prop self.es_main_es_info:");
            console.log(self.es_main_es_info);
          });

      },
      reportDownload() {
        let self = this;
        let url = self.$root.baseUrl + '/inventory-management/unique_component/ftie/inventory_download/';
        console.log('####inventory management - download######');

        let downloadTime = new Date();
        let download_dict = [];

        for (let i = 0; i < self.ticketWithUniqueInfo.inventory_info_list.length; i++) {
          download_dict.push({
            unique_component_pn: self.ticketWithUniqueInfo.inventory_info_list[i].unique_component_pn,
            unique_component_pn_desc: self.ticketWithUniqueInfo.inventory_info_list[i].unique_component_pn_desc,
            project_name: self.ticketWithUniqueInfo.inventory_info_list[i].project_name,
            stock_qty: self.ticketWithUniqueInfo.inventory_info_list[i].stock_qty,
            po_qty_total: self.ticketWithUniqueInfo.inventory_info_list[i].po_qty_total,
            pr_qty_total: self.ticketWithUniqueInfo.inventory_info_list[i].pr_qty_total,
            possible_surplus: self.ticketWithUniqueInfo.inventory_info_list[i].possible_surplus,
            surplus: self.ticketWithUniqueInfo.inventory_info_list[i].surplus,
          });
        }
        downloadTime = downloadTime.toISOString();
        let request_data = {
          download_dict: download_dict,
          downloadTime: downloadTime,
          ftie_id: self.ticketWithUniqueInfo.ftie_id
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = self.ticketWithUniqueInfo.ftie_id + '_inventory_report_.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      showInventoryDetailData(inventory_info_list, unique_component_pn) {
        let self = this;
        let displayInventoryInfoList = [];
        let wipStockQty = 0;
        for (let i = 0; i < inventory_info_list.length; i++) {
          if (inventory_info_list[i].SUBINVENTORY_CODE == "P" || inventory_info_list[i].SUBINVENTORY_CODE == "ET1") {
            displayInventoryInfoList.push(inventory_info_list[i])
          } else {
            wipStockQty += inventory_info_list[i].INVENTORY_QTY;
          }
        }
        if (wipStockQty != 0) {
          displayInventoryInfoList.push({
            SUBINVENTORY_CODE: "WIP",
            SUBINVENTORY_NAME: "WIP",
            INVENTORY_QTY: wipStockQty
            })
        }
        self.detaiInventoryToShow = {
          inventory_info_list: displayInventoryInfoList,
          unique_component_pn: unique_component_pn
        };

      },
      inventoryReportAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        if ((user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1) || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
          || (user_roles && _.indexOf(user_roles, 'HQ_ES') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1) || (user_roles && _.indexOf(user_roles, 'HQ_Sales') > -1)
          || (user_functions && _.indexOf(user_functions, 'Getac Sales Manager') > -1) || (user_functions && _.indexOf(user_functions, 'GRO TOP Manager') > -1)
        ) {
          console.log("Access to inventory report!");
          return true
        }
        return false;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/unique-compo-inventory/FTIEInventoryPage.vue